<template>
    <div>
        <div class="complaint-container clearfix swb-back-row">
            <div class="breadcrumb-layout">
                <el-breadcrumb separator=">">
                    <el-breadcrumb-item :to="{ path: '/' }">投诉意见</el-breadcrumb-item>
                    <el-breadcrumb-item>查看详情</el-breadcrumb-item>
                </el-breadcrumb>
                <div class="right" @click="$router.back(-1)">
                    <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
                </div>
            </div>
            <div class="complaint-content mr15" style="margin-left: 0; ">
                <h4 class="title">
                    <span>{{complaintInfo.srcMerchantName}} 投诉 {{complaintInfo.dstMerchantName}}</span>
                    <div class="fr" v-if="!complaintInfo.closed">
                        <div v-if="complaintInfo.acceptState != 0">
                            <button class="swb-btn swb-btn-mini" @click="complaintSend(complaintInfo.id)">重新申诉</button>
                            <button class="swb-btn swb-btn-mini" @click="arbitration(complaintInfo.id)">平台介入</button>
                            <button class="swb-btn swb-btn-mini" @click="complaintEnd(complaintInfo.id)">结束申诉</button>
                        </div>
                    </div>
                    <div class="fr" v-else>
                        <a class="swb-btn-link">投诉已关闭</a>
                    </div>
                </h4>
                <div class="pl10 pr10 pb10">
                    <div class="complaint-panel" v-for="complaintRec in complaintRecList">
                        <div class="complaint-panel-item">
                            <h4>
                                <span class="">{{complaintInfo.srcMerchantName}}</span>
                                <span>{{complaintInfo.submitTime}}</span>
                            </h4>
                            <p class="ml5">
                                <span class="font16 font-bold">投诉内容：</span>
                                <span>{{complaintRec.srcContent}}</span>
                            </p>
                            <p class="ml5 mt10">
                                <span class="font16 font-bold">处理要求：</span>
                                <span>{{complaintRec.srcDemand}}</span>
                            </p>
                            <div class="img111"></div>
                        </div>
                        <div class="complaint-panel-item">
                            <h4 class="align-right">
                                <span>{{complaintInfo.dstMerchantName}}</span>
                                <span>{{complaintInfo.submitTime}}</span>
                            </h4>
                            <p class="align-right" v-if="complaintRec.dstAcceptState == 1"><a class="swb-btn-link">已接收</a></p>
                            <p class="align-right" v-if="complaintRec.dstAcceptState == -1"><a class="swb-btn-link"></a>已拒绝</p>
                            <p class="ml5">
                                <span class="font14 font-bold">留言说明：</span>
                                <span>{{complaintRec.dstContent || '无'}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order-info" v-if="complaintorderOrderInfo != null">
                <h4 class="title">订单信息</h4>
                <div class="order-content">
                    <div class="order-content-row">
                        <div class="left">订单编号：</div>
                        <div class="right font-blue">{{complaintorderOrderInfo.no || '无'}}</div>
                    </div>
                    <div class="order-content-row">
                        <div class="left">总计：</div>
                        <div class="right font-red">{{complaintorderOrderInfo.amount || '0'}}元</div>
                    </div>
                    <div class="order-content-row">
                        <div class="left">提交时间：</div>
                        <div class="right">{{complaintorderOrderInfo.submitTime || '无'}}</div>
                    </div>
                    <div class="order-content-row">
                        <div class="left">商家：</div>
                        <div class="right font-blue">{{complaintorderOrderInfo.buyerName || '无'}}</div>
                    </div>
                </div>
            </div>
            <div class="order-info" v-else>
                <h4 class="title">订单信息</h4>
                <div class="order-content align-center" style="min-height: 170px;line-height: 170px">
                    <span class="font16">暂无数据。。。</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import custsvcApi from '../../api/custsvc'

    import SwbComplaintSave from './ComplaintSave';
    Routes.add(SwbComplaintSave);
    import SwbComplaintSendList from './ComplaintSendList';
    Routes.add(SwbComplaintSendList);

    export default {
        name: 'swb-complaint-info',
        path: '/complaint/detail',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        customBreadcrumb: false,
        parentBreadcrumbUrl: '/complaint/sent/list',
        desc: '投诉详情',
        data: function () {
            return {
                complaintInfo: {},
                complaintReqRecList: [],
                complaintRecList: [],
                complaintorderOrderInfo: {}
            }
        },
        created: function () {
            let complaintId = this.$route.query.complaintId;
            //
            this.getComplaintInfo(complaintId);
            // 投诉请求
            this.getComplaintReqRec(complaintId);
        },
        methods: {
            getComplaintInfo: function (complaintId) {
                let self = this;
                let postData = {};
                postData.id = complaintId;
                let theLoad = MsgBox.loading();
                custsvcApi.getComplaintInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.complaintInfo = result.data;
                        // 获取订单信息
                        self.getOrderInfo(self.complaintInfo.subjectId, self.complaintInfo.subjectType);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getComplaintReqRec: function (complaintId) {
                let self = this;
                let postData = {};
                postData.complaintId = complaintId;
                let theLoad = MsgBox.loading();
                custsvcApi.getComplaintReqRecList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.complaintReqRecList = result.data;
                        // 投诉响应
                        self.getComplaintRspRec(complaintId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getComplaintRspRec: function (complaintId) {
                let self = this;
                let postData = {};
                postData.complaintId = complaintId;
                let theLoad = MsgBox.loading();
                custsvcApi.getComplaintRspRecList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let complaintRspRecList = result.data;  // 响应记录
                        let complaintReqRecList = self.complaintReqRecList;     // 请求记录
                        // 处理 请求-响应 数据
                        for(let i = 0; i < complaintReqRecList.length; i++) {
                            let complaintReqRec = complaintReqRecList[i];
                            //
                            if(complaintRspRecList == null || complaintRspRecList.length == 0) {// 未返回处理信息
                                // 请求信息
                                let complaintRec = [];
                                complaintRec.srcContent = complaintReqRec.content;
                                complaintRec.srcDemand = complaintReqRec.demand;
                                //
                                self.complaintRecList.push(complaintRec);
                            } else {// 已返回处理信息
                                for(let j = 0; j < complaintRspRecList.length; j++) {
                                    let complaintRspRec = complaintRspRecList[j];
                                    // console.log(complaintReqRec.theTimes);
                                    // console.log(complaintRspRec.theTimes);
                                    if(complaintReqRec.theTimes === complaintRspRec.theTimes) {
                                        let complaintRec = {};
                                        // complaintRec.srcAcceptState = complaintReqRec.acceptState;
                                        // 请求数据
                                        complaintRec.srcContent = complaintReqRec.content;
                                        complaintRec.srcDemand = complaintReqRec.demand;
                                        // 响应数据
                                        complaintRec.dstAcceptState = complaintRspRec.acceptState;
                                        complaintRec.dstContent = complaintRspRec.handleContent;
                                        //
                                        self.complaintRecList.push(complaintRec);
                                    }
                                }
                            }
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 订单信息
            getOrderInfo: function (subjectId, subjectType) {
                let self = this;
                let postData = {};
                postData.subjectId = subjectId;
                postData.subjectType = subjectType;
                let theLoad = MsgBox.loading();
                custsvcApi.getComplaintOrderInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.complaintorderOrderInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 重新申诉
            complaintSend: function (complaintId) {
                let self = this;
                let postData = {};
                postData.id = complaintId;
                self.$router.push({
                    path: SwbComplaintSave.path,
                    query: {
                        complaintId: complaintId
                    }
                });
            },
            // 平台仲裁
            arbitration: function (complaintId) {
                let self = this;
                let postData = {};
                postData.id = complaintId;
                self.$router.push({
                    path: SwbComplaintSave.path,
                    query: {
                        complaintId: complaintId,
                        mode: true,     // 前台判断是否为 平台仲裁
                    }
                });
            },
            // 结束投诉
            complaintEnd: function (complaintId) {
                let self = this;
                let postData = {};
                postData.id = complaintId;
                postData.closed = true;
                let theLoad = MsgBox.loading();
                custsvcApi.finishConfirmComplaint(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.$router.push({
                            path: SwbComplaintSendList.path
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/custsvc/ComplaintInfo.vue